<div class="card">
  <h2 class="text-xl font-semibold mb-4">
    {{ 'project.steps.architectural-principles.title' | transloco }}
  </h2>

  @if (isLoading()) {
    <app-loading />
  } @else {
    <form (ngSubmit)="onSave()" class="flex flex-col gap-4">
      @for (opt of options(); track opt.id) {
        <div class="flex items-stretch gap-3">
          <div class="w-12 bg-third-level flex items-center justify-center font-bold rounded-lg">
            AP{{ $index + 1 }}
          </div>
          <button
            type="button"
            class="flex-1 p-3 rounded-lg bg-third-level cursor-pointer flex items-center justify-between border-0 focus:outline-hidden"
            (click)="onSelect(opt.id)"
            [disabled]="isButtonDisabled()"
            [attr.data-testid]="'option-' + $index + '-button'"
          >
            <span class="font-medium">{{ opt.translations | translateDirectus }}</span>
            <p-radioButton
              [inputId]="'opt-' + $index"
              name="principle"
              [value]="opt.id"
              [ngModel]="selected()"
              [disabled]="isButtonDisabled()"
              [style]="{'--p-radiobutton-icon-disabled-color': 'var(--p-red-700)'}"
              (ngModelChange)="onSelect($event)"
            ></p-radioButton>
          </button>
        </div>
      } @empty {
        <app-no-data />
      }
      @if (options().length > 0) {
        <div class="flex flex-col gap-2 mt-2">
          <label for="architectural-principle-explanation" class="font-medium">
            {{ 'project.steps.architectural-principles.explanation.label' | transloco }}
          </label>
          <textarea
            id="architectural-principle-explanation"
            name="explanation"
            pTextarea
            rows="4"
            class="w-full"
            [ngModel]="explanation()"
            (ngModelChange)="onExplanationChange($event)"
            [disabled]="isButtonDisabled()"
            [placeholder]="
              'project.steps.architectural-principles.explanation.placeholder' | transloco
            "
            data-testid="architectural-principle-explanation"
          ></textarea>
        </div>
      }
      @if (canSave()) {
        <div class="flex justify-end gap-2 mt-2">
          <app-project-step-save-button [loading]="saving()" (clicked)="onSave()" />
        </div>
      }
    </form>
  }
</div>
